/* MIXORA · comportamiento de la landing */
(function () {
  'use strict';

  /* ── Galería ─────────────────────────────────────────── */
  function initGaleria() {
    document.querySelectorAll('[data-mx-gal]').forEach(function (gal) {
      var main = gal.querySelector('[data-mx-gal-main]');
      gal.querySelectorAll('[data-mx-gal-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          main.src = btn.dataset.full;
          main.srcset = '';
          gal.querySelectorAll('[data-mx-gal-thumb]').forEach(function (b) {
            b.setAttribute('aria-current', b === btn ? 'true' : 'false');
          });
        });
      });
    });
  }

  /* ── Contador regresivo (se reinicia cada visita) ────── */
  function initContador() {
    document.querySelectorAll('[data-mx-contador]').forEach(function (box) {
      var mins = parseInt(box.dataset.mxContador, 10) || 15;
      var fin = Date.now() + mins * 60000;
      var elMin = box.querySelector('[data-min]');
      var elSec = box.querySelector('[data-sec]');
      var elMs = box.querySelector('[data-ms]');
      function tick() {
        var d = fin - Date.now();
        if (d <= 0) { fin = Date.now() + mins * 60000; d = mins * 60000; }
        var m = Math.floor(d / 60000);
        var s = Math.floor((d % 60000) / 1000);
        var ms = Math.floor((d % 1000) / 10);
        elMin.textContent = String(m).padStart(2, '0');
        elSec.textContent = String(s).padStart(2, '0');
        elMs.textContent = String(ms).padStart(2, '0');
      }
      tick();
      setInterval(tick, 60);
    });
  }

  /* ── Fechas de entrega dinámicas ─────────────────────── */
  function initFechas() {
    var meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    function fmt(d, largo) {
      if (largo) {
        return String(d.getDate()).padStart(2, '0') + '/' +
               String(d.getMonth() + 1).padStart(2, '0') + '/' + d.getFullYear();
      }
      return meses[d.getMonth()] + ' ' + d.getDate();
    }
    document.querySelectorAll('[data-mx-fecha]').forEach(function (el) {
      var dias = parseInt(el.dataset.mxFecha, 10) || 0;
      var d = new Date();
      d.setDate(d.getDate() + dias);
      el.textContent = fmt(d, el.dataset.mxFormato === 'largo');
    });
  }

  /* ── Barra sticky ────────────────────────────────────── */
  function initSticky() {
    var bar = document.querySelector('[data-mx-sticky]');
    if (!bar) return;
    function chk() { bar.classList.toggle('is-on', window.scrollY > 600); }
    window.addEventListener('scroll', chk, { passive: true });
    chk();
  }

  /* ── Botón sticky y CTAs secundarios disparan el form ── */
  function initCtas() {
    document.querySelectorAll('[data-mx-comprar]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var form = document.querySelector('[data-mx-form]');
        if (form) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : form.submit(); }
      });
    });
  }

  /* ── Popups de prueba social ─────────────────────────── */
  function initPopups() {
    var host = document.querySelector('[data-mx-pop]');
    if (!host) return;
    var nombres = (host.dataset.nombres || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var ciudades = (host.dataset.ciudades || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var cada = (parseInt(host.dataset.cada, 10) || 25) * 1000;
    var dura = (parseInt(host.dataset.dura, 10) || 7) * 1000;
    var tagEl = host.querySelector('[data-tag]');
    var txtEl = host.querySelector('[data-txt]');
    var timeEl = host.querySelector('[data-time]');
    var icoEl = host.querySelector('[data-ico]');
    var cerrado = false;
    var turno = 0;

    host.querySelector('[data-mx-pop-x]').addEventListener('click', function () {
      cerrado = true;
      host.classList.remove('is-on');
    });

    function pick(a) { return a[Math.floor(Math.random() * a.length)]; }

    function mostrar() {
      if (cerrado || !nombres.length) return;
      if (turno % 2 === 0) {
        icoEl.textContent = '🛒';
        tagEl.textContent = 'Compra reciente';
        txtEl.textContent = pick(nombres) + ' de ' + pick(ciudades) + ' acaba de comprar este producto';
        timeEl.textContent = 'Pedido confirmado hace ' + (Math.floor(Math.random() * 8) + 2) + ' minutos';
      } else {
        icoEl.textContent = '🔥';
        tagEl.textContent = 'Alta demanda';
        txtEl.textContent = 'Quedan pocas unidades disponibles de este producto';
        timeEl.textContent = (Math.floor(Math.random() * 12) + 4) + ' personas lo están viendo ahora';
      }
      turno++;
      host.classList.add('is-on');
      setTimeout(function () { host.classList.remove('is-on'); }, dura);
    }

    setTimeout(function () { mostrar(); setInterval(mostrar, cada); }, 6000);
  }

  function init() {
    initGaleria();
    initContador();
    initFechas();
    initSticky();
    initCtas();
    initPopups();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

/* Menú móvil del tema */
(function () {
  function initMenu() {
    var panel = document.querySelector('[data-mx-menu]');
    if (!panel) return;
    var abrir = document.querySelector('[data-mx-menu-abrir]');
    var cerrar = document.querySelector('[data-mx-menu-cerrar]');
    function on() { panel.hidden = false; document.body.style.overflow = 'hidden'; }
    function off() { panel.hidden = true; document.body.style.overflow = ''; }
    if (abrir) abrir.addEventListener('click', on);
    if (cerrar) cerrar.addEventListener('click', off);
    panel.addEventListener('click', function (e) { if (e.target === panel) off(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') off(); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenu);
  } else { initMenu(); }
  document.addEventListener('shopify:section:load', initMenu);
})();
